import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { categories } from "@/mocks/categories";
import SearchBar from "./SearchBar";

const navLinks = [
  { to: "/", label: "首页" },
  { to: "/search", label: "搜索" },
  { to: "/favorites", label: "收藏" },
  { to: "/about", label: "关于" },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
    setCategoryOpen(false);
  }, [location.pathname, location.search]);

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition ${
      isActive
        ? "text-primary-600"
        : "text-foreground-600 hover:bg-background-100 hover:text-foreground-900"
    }`;

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/80 bg-background-50/90 backdrop-blur">
      <div className="mx-auto flex h-16 w-full items-center gap-4 px-4 md:px-6">
        <Link to="/" className="flex shrink-0 items-center gap-2" aria-label="91短视频首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-play-fill text-xl"></i>
          </span>
          <span className="font-logo text-xl leading-none text-foreground-900">91短视频</span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.slice(0, 1).map((link) => (
            <NavLink key={link.to} to={link.to} className={linkClass}>
              {link.label}
            </NavLink>
          ))}

          <div
            className="relative"
            onMouseEnter={() => setCategoryOpen(true)}
            onMouseLeave={() => setCategoryOpen(false)}
          >
            <button
              type="button"
              onClick={() => setCategoryOpen((open) => !open)}
              className="flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-600 transition hover:bg-background-100 hover:text-foreground-900"
            >
              分类
              <i
                className={`ri-arrow-down-s-line text-base transition-transform ${
                  categoryOpen ? "rotate-180" : ""
                }`}
              ></i>
            </button>
            {categoryOpen && (
              <div className="absolute left-0 top-full z-50 w-52 pt-2">
                <div className="animate-fade-in overflow-hidden rounded-lg border border-background-200 bg-background-50 py-1 shadow-sm">
                  {categories.map((category) => (
                    <Link
                      key={category.slug}
                      to={`/category/${category.slug}`}
                      className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 transition hover:bg-background-100 hover:text-primary-600"
                    >
                      <i className={`${category.icon} text-lg text-accent-500`}></i>
                      {category.name}短视频
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>

          {navLinks.slice(1).map((link) => (
            <NavLink key={link.to} to={link.to} className={linkClass}>
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto hidden w-full max-w-xs lg:block">
          <SearchBar />
        </div>

        <button
          type="button"
          onClick={() => setMenuOpen((open) => !open)}
          aria-label="打开菜单"
          className="ml-auto flex h-10 w-10 cursor-pointer items-center justify-center rounded-md text-foreground-800 transition hover:bg-background-100 md:hidden"
        >
          <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="animate-fade-in border-t border-background-200 bg-background-50 px-4 py-4 md:hidden">
          <SearchBar onSubmitted={() => setMenuOpen(false)} />
          <nav className="mt-3 flex flex-col">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                className={({ isActive }) =>
                  `flex items-center gap-2 rounded-md px-3 py-3 text-sm font-medium transition ${
                    isActive
                      ? "bg-primary-50 text-primary-600"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>
          <div className="mt-3 border-t border-background-200 pt-3">
            <p className="mb-2 px-3 text-xs font-medium uppercase tracking-wide text-foreground-400">
              视频分类
            </p>
            <div className="grid grid-cols-2 gap-2">
              {categories.map((category) => (
                <Link
                  key={category.slug}
                  to={`/category/${category.slug}`}
                  className="flex items-center gap-2 rounded-md bg-background-100 px-3 py-2.5 text-sm text-foreground-700"
                >
                  <i className={`${category.icon} text-lg text-accent-500`}></i>
                  {category.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}